<template>
  <div class="puzzle-grid-zoom">
    <div class="d-flex justify-content-center align-items-center mt-3 mb-2">
      <d-button
        type="button"
        class="btn-outline-secondary btn-sm"
        :disabled="!canZoomOut"
        :title="$t('shared.puzzle.grid.zoomOut')"
        @click="zoomOut"
      >
        <i class="fas fa-search-minus" />
      </d-button>
      <span class="mx-2 text-muted small zoom-label"> {{ zoomPercent }}% </span>
      <d-button
        type="button"
        class="btn-outline-secondary btn-sm"
        :disabled="!canZoomIn"
        :title="$t('shared.puzzle.grid.zoomIn')"
        @click="zoomIn"
      >
        <i class="fas fa-search-plus" />
      </d-button>
    </div>

    <div
      class="overflow-auto d-flex justify-content-center"
      @wheel="onWheelZoom"
    >
      <slot
        :zoom="zoom"
        :display-cell-size="displayCellSize"
        :display-font-size="displayFontSize"
        :grid-style="gridStyle"
        :letter-style="letterStyle"
      />
    </div>
  </div>
</template>

<script>
export const GRID_ZOOM = {
  MIN: 0.4,
  MAX: 1.6,
  STEP: 0.1,
  DEFAULT: 1,
};

const DEFAULT_CELL_SIZE = 60;

export default {
  name: 'puzzle-grid-zoom',
  props: {
    rows: {
      type: Number,
      required: true,
    },
    columns: {
      type: Number,
      required: true,
    },
    cellSize: {
      type: Number,
      default: DEFAULT_CELL_SIZE,
    },
  },
  data() {
    return {
      zoom: GRID_ZOOM.DEFAULT,
    };
  },
  computed: {
    displayCellSize() {
      return Math.max(12, Math.round(this.cellSize * this.zoom));
    },
    displayFontSize() {
      return Math.max(8, Math.round(this.displayCellSize * 0.7));
    },
    zoomPercent() {
      return Math.round(this.zoom * 100);
    },
    canZoomOut() {
      return this.zoom > GRID_ZOOM.MIN;
    },
    canZoomIn() {
      return this.zoom < GRID_ZOOM.MAX;
    },
    gridStyle() {
      const size = this.displayCellSize;
      return {
        'grid-template-rows': `repeat(${this.rows}, ${size}px)`,
        'grid-template-columns': `repeat(${this.columns}, ${size}px)`,
      };
    },
    letterStyle() {
      return {
        fontSize: `${this.displayFontSize}px`,
      };
    },
  },
  methods: {
    clampZoom(value) {
      return Math.min(GRID_ZOOM.MAX, Math.max(GRID_ZOOM.MIN, value));
    },
    zoomIn() {
      this.zoom = this.clampZoom(
        Math.round((this.zoom + GRID_ZOOM.STEP) * 10) / 10,
      );
    },
    zoomOut() {
      this.zoom = this.clampZoom(
        Math.round((this.zoom - GRID_ZOOM.STEP) * 10) / 10,
      );
    },
    onWheelZoom(event) {
      if (!event.ctrlKey && !event.metaKey) return;
      event.preventDefault();
      if (event.deltaY < 0) this.zoomIn();
      else if (event.deltaY > 0) this.zoomOut();
    },
  },
};
</script>

<style scoped>
.zoom-label {
  min-width: 3.5rem;
  text-align: center;
}
</style>
